export const TASKS_CONTRACTOR_SELECT = 'TASKS_CONTRACTOR_SELECT';
export const TASKS_LOAD_SUCCESS = 'TASKS_LOAD_SUCCESS';
export const TASKS_PAGE_CHANGE = 'TASKS_PAGE_CHANGE';
export const TASKS_TRADES_SELECT = 'TASKS_TRADES_SELECT';
export const TASKS_TRADES_SUCCESS = 'TASKS_TRADES_SUCCESS';
export const TASKS_UI_INITIALIZE = 'TASKS_UI_INITIALIZE';



// WEBPACK FOOTER //
// ./src/actions/admin/tasks/action-types.js